import { render, staticRenderFns } from "./DocumentValuesIndicatorPanel.vue?vue&type=template&id=74c13b00"
import script from "./DocumentValuesIndicatorPanel.vue?vue&type=script&lang=js"
export * from "./DocumentValuesIndicatorPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports